import { ImmomioIconName } from '../general';
import {
  ResidentFeedbackCategory,
  ResidentFeedbackPlatform,
  ResidentFeedbackResult,
} from './feedback.enum';

export const FEEDBACK_COMMENT_MAX_LENGTH = 500;

/**
 * Caps on the metadata fields, enforced client-side before the mutation goes out.
 *
 * `saveFeedback` never returns `false` — it either returns `true` or fails with a
 * GraphQL error, and an over-long field is one of the four ways it can fail
 * (`ERROR_FEEDBACK_OS_VERSION_TOO_LONG`, `ERROR_FEEDBACK_APP_VERSION_TOO_LONG`).
 * The BE rejects rather than truncating, and a rejected save is invisible to the
 * resident (fire-and-forget, spec ED-1), so clamping beats letting it fail.
 *
 * 50 is provisional: the server-side limits are not published, and it sits far
 * above anything real these fields carry — `Device.osVersion` is `"18.2"`-shaped
 * and `appVersion` is the package version, `"1.0.0"`. Narrow these if BE confirms
 * a lower bound.
 */
export const FEEDBACK_OS_VERSION_MAX_LENGTH = 50;
export const FEEDBACK_APP_VERSION_MAX_LENGTH = 50;

export interface IResidentFeedbackInput {
  result: ResidentFeedbackResult;
  category?: ResidentFeedbackCategory | null;
  comment?: string | null;
  platform: ResidentFeedbackPlatform;
  osVersion?: string | null;
  appVersion?: string | null;
}

export interface IResidentFeedbackEligibility {
  eligible: boolean;
}

/**
 * Device/app context supplied by the platform layer. The shared component never
 * touches native APIs, so web can hand it `{ platform: WEB_MOBILE, ... }` unchanged.
 */
export interface IResidentFeedbackContext {
  platform: ResidentFeedbackPlatform;
  osVersion: string | null;
  appVersion: string | null;
}

export interface IFeedbackCategoryOption {
  category: ResidentFeedbackCategory;
  labelKey: string;
  icon: ImmomioIconName | null;
}

/**
 * Figma order. `Sonstiges` has no icon in the design.
 */
export const FEEDBACK_CATEGORY_OPTIONS: IFeedbackCategoryOption[] = [
  {
    category: ResidentFeedbackCategory.BUG,
    labelKey: 'feedback_prompt.category_bug_l',
    icon: ImmomioIconName.Hammer,
  },
  {
    category: ResidentFeedbackCategory.IDEA,
    labelKey: 'feedback_prompt.category_idea_l',
    icon: ImmomioIconName.LightBulb,
  },
  {
    category: ResidentFeedbackCategory.UX,
    labelKey: 'feedback_prompt.category_ux_l',
    icon: ImmomioIconName.Window,
  },
  {
    category: ResidentFeedbackCategory.OTHER,
    labelKey: 'feedback_prompt.category_other_l',
    icon: null,
  },
];
